import { render, staticRenderFns } from "./Brandtable.vue?vue&type=template&id=7e951088&scoped=true"
import script from "./Brandtable.vue?vue&type=script&lang=js"
export * from "./Brandtable.vue?vue&type=script&lang=js"
import style0 from "./Brandtable.vue?vue&type=style&index=0&id=7e951088&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e951088",
  null
  
)

export default component.exports